var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('h1',{staticClass:"intro__heading",domProps:{"innerHTML":_vm._s(this.heading)}}),_vm._v(" "),_c('p',{staticClass:"intro__description",domProps:{"innerHTML":_vm._s(this.description)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142b1289","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/components/Intro.vue
// module id = null
// module chunks = 